<template>
  <master-layout class="login">
    <v-container class="content-container ">
      <v-container fluid class="component-container-1400mw">
        <authentication-container
        ></authentication-container>
      </v-container>
    </v-container>
  </master-layout>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import MasterLayout from '~/layouts/MasterLayout.vue';
import LoadingDialog from "~/components/utils/LoadingDialog.vue";
import AuthenticationContainer from "~/components/auth/AuthenticationContainer.vue";

export default defineComponent({
  components: {AuthenticationContainer, LoadingDialog, MasterLayout},
  setup() {
    definePageMeta({
      middleware: [
        'guest',
      ],
    });

    useHead({
      title: 'Xiga | Autentificare',
      meta: [
        {
          name: 'description',
          content: 'META'
        }
      ],
    });
  }
});
</script>

<style scoped>

</style>
